export default {
  setLoginUIState: (state, value) => state.loginUIState = value
}